// @flow
import React, { Component } from 'react';
import {
  TextArea, Checkbox, Radio, RadioGroup,
} from 'informed';

import { PrimaryText, SecondaryText } from '../../../Typography.jsx';
import ContentBox from '../../../ContentBox.jsx';
import { Button } from '../../../Buttons.jsx';

import styles from '../../../../styles/patientPages/progressNote/progressNote.scss';

type Props = {
  initGenitourinary: Object,
  resetUrinaryRadios: Function,
}

class EditGenitourniary extends Component<Props> {
  render() {
    const genitourinary = this.props.initGenitourinary || {};
    return (
      <ContentBox title='Genitourinary'>
        <div className={styles.col}>
          <Button onClick={this.props.resetUrinaryRadios}>Clear Radios</Button><br />
          <PrimaryText>Urinary System Assessment</PrimaryText><br />
          <div className={styles.section}>
            <SecondaryText>Urination mode:</SecondaryText><br />
            <RadioGroup field='genitourinary.voiding' initialValue={genitourinary.voiding}>
              <Radio value='voiding' />Voiding<br />
              <Radio value='foley cath' />Foley catheter to gravity drain<br />
              <Radio value='straight cath self' />Straight catheter by self/family<br />
              <Radio value='straight cath staff' />Straight catheter by staff<br />
              <Radio value='diversion' />Urinary diversion<br />
              <Radio value='anuric' />Anuric
            </RadioGroup>
          </div>
          <PrimaryText>Urine Color/Characteristics</PrimaryText><br />
          <div className={styles.section}>
            <SecondaryText>Color:</SecondaryText><br />
            <RadioGroup field='genitourinary.urineColor' initialValue={genitourinary.urineColor}>
              <Radio value='yellow straw' />Yellow, straw-colored<br />
              <Radio value='pale yellow' />Pale yellow<br />
              <Radio value='dark yellow' />Dark yellow<br />
              <Radio value='amber' />Amber<br />
              <Radio value='dark brown' />Dark brown<br />
              <Radio value='green-brown' />Green-brown<br />
              <Radio value='orange-red' />Orange-red<br />
              <Radio value='orange-brown' />Orange-brown<br />
              <Radio value='red-brown' />Red-brown<br />
              <Radio value='frank blood' />Frank blood
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Characteristics:</SecondaryText><br />
            <RadioGroup field='genitourinary.urineChars' initialValue={genitourinary.urineChars}>
              <Radio value='clear' />Clear<br />
              <Radio value='cloudy' />Cloudy<br />
              <Radio value='precipitates' />Precipitates, sediment visible<br />
              <Radio value='clots' />Clots visible<br />
              <Radio value='milky' />Milky
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Odor:</SecondaryText><br />
            <RadioGroup field='genitourinary.odor' initialValue={genitourinary.odor}>
              <Radio value='no odor' />No odor<br />
              <Radio value='unusual' />Unusual odor<br />
              <Radio value='foul' />Foul odor<br />
              <Radio value='ammonia' />Ammonia odor<br />
              <Radio value='sweet' />Sweet odor
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Urinary assessment:</SecondaryText><br />
            <Checkbox field='genitourinary.noUrinaryProbs' initialValue={genitourinary.noUrinaryProbs} />No urinary problems noted
          </div>
          <div className={styles.section}>
            <SecondaryText>Mark all that apply:</SecondaryText><br />
            <Checkbox field='genitourinary.noIncont' initialValue={genitourinary.noIncont} />No urinary incontinence<br />
            <Checkbox field='genitourinary.occIncont' initialValue={genitourinary.occIncont} />Occasional incontinence<br />
            <Checkbox field='genitourinary.stressIncont' initialValue={genitourinary.stressIncont} />Stress incontinence<br />
            <Checkbox field='genitourinary.freqIncont' initialValue={genitourinary.freqIncont} />Frequent incontinence<br />
            <Checkbox field='genitourinary.bladderDistent' initialValue={genitourinary.bladderDistent} />Bladder distention<br />
            <Checkbox field='genitourinary.urineRetent' initialValue={genitourinary.urineRetent} />Urine retention<br />
            <Checkbox field='genitourinary.painUrine' initialValue={genitourinary.painUrine} />Pain on urination<br />
            <Checkbox field='genitourinary.burnUrine' initialValue={genitourinary.burnUrine} />Burning on urination<br />
            <Checkbox field='genitourinary.urgency' initialValue={genitourinary.urgency} />Urgency<br />
            <Checkbox field='genitourinary.freqUrine' initialValue={genitourinary.freqUrine} />Frequency<br />
            <Checkbox field='genitourinary.hesitancy' initialValue={genitourinary.hesitancy} />Hesitancy<br />
            <Checkbox field='genitourinary.dysuria' initialValue={genitourinary.dysuria} />Dysuria<br />
            <Checkbox field='genitourinary.oliguria' initialValue={genitourinary.oliguria} />Oliguria<br />
            <Checkbox field='genitourinary.nocturia' initialValue={genitourinary.nocturia} />Nocturia<br />
            <Checkbox field='genitourinary.pyuria' initialValue={genitourinary.pyuria} />Pyuria
          </div>
          <div className={styles.section}>
            <SecondaryText>Urinary notes:</SecondaryText><br />
            <TextArea field='genitourinary.urinaryNotes' initialValue={genitourinary.urinaryNotes} />
          </div>
          <PrimaryText>Dialysis</PrimaryText><br />
          <div className={styles.section}>
            <SecondaryText>Peritoneal dialysis:</SecondaryText><br />
            <Checkbox field='genitourinary.peritoneal' initialValue={genitourinary.peritoneal} />Undergoing peritoneal dialysis<br />
            <Checkbox field='genitourinary.renal' initialValue={genitourinary.renal} />Undergoing renal dialysis
          </div>
          <PrimaryText>Male</PrimaryText><br />
          <div className={styles.section}>
            <SecondaryText>Penis assessment:</SecondaryText><br />
            <Checkbox field='genitourinary.noPenProbs' initialValue={genitourinary.noPenProbs} />No problems noted
          </div>
          <div className={styles.section}>
            <SecondaryText>Mark all that apply</SecondaryText><br />
            <Checkbox field='genitourinary.penLesion' initialValue={genitourinary.penLesion} />Lesion (describe in Notes)<br />
            <Checkbox field='genitourinary.penNodules' initialValue={genitourinary.penNodules} />Nodules (describe in Notes)<br />
            <Checkbox field='genitourinary.penInflame' initialValue={genitourinary.penInflame} />Inflammation<br />
            <Checkbox field='genitourinary.penRed' initialValue={genitourinary.penRed} />Redness<br />
            <Checkbox field='genitourinary.penSwell' initialValue={genitourinary.penSwell} />Swelling<br />
            <Checkbox field='genitourinary.penDischarge' initialValue={genitourinary.penDischarge} />Discharge (describe in Notes)<br />
            <Checkbox field='genitourinary.penGenWarts' initialValue={genitourinary.penGenWarts} />Genital warts<br />
            <Checkbox field='genitourinary.penCirc' initialValue={genitourinary.penCirc} />Circumcised<br />
            <Checkbox field='genitourinary.penNotCirc' initialValue={genitourinary.penNotCirc} />Not circumcised<br />
            <Checkbox field='genitourinary.penNoRetract' initialValue={genitourinary.penNoRetract} />Unable to retract foreskin<br />
            <Checkbox field='genitourinary.penDisplaced' initialValue={genitourinary.penDisplaced} />Displaced meatus
          </div>
          <div className={styles.section}>
            <SecondaryText>Scrotum/testes assessment</SecondaryText><br />
            <Checkbox field='genitourinary.noScrotProbs' initialValue={genitourinary.noScrotProbs} />No problems noted
          </div>
          <div className={styles.section}>
            <SecondaryText>Mark all that apply:</SecondaryText><br />
            <Checkbox field='genitourinary.scrotLesion' initialValue={genitourinary.scrotLesion} />Lesion (describe in Notes)<br />
            <Checkbox field='genitourinary.scrotNodules' initialValue={genitourinary.scrotNodules} />Nodules (describe in Notes)<br />
            <Checkbox field='genitourinary.scrotInflame' initialValue={genitourinary.scrotInflame} />Inflammation, redness<br />
            <Checkbox field='genitourinary.scrotEdema' initialValue={genitourinary.scrotEdema} />Edema<br />
            <Checkbox field='genitourinary.scrotUndesc' initialValue={genitourinary.scrotUndesc} />One or both testicles undescended<br />
            <Checkbox field='genitourinary.scrotDistVein' initialValue={genitourinary.scrotDistVein} />Distended veins<br />
            <Checkbox field='genitourinary.scrotHydrocele' initialValue={genitourinary.scrotHydrocele} />Hydrocele<br />
            <Checkbox field='genitourinary.scrotCystocele' initialValue={genitourinary.scrotCystocele} />Cystocele<br />
            <Checkbox field='genitourinary.scrotLump' initialValue={genitourinary.scrotLump} />Lump/mass noted (descibe in Notes)<br />
            <Checkbox field='genitourinary.scrotNits' initialValue={genitourinary.scrotNits} />Nits or parasites noted
          </div>
          <div className={styles.section}>
            <SecondaryText>Genitalia notes:</SecondaryText><br />
            <TextArea field='genitourinary.genNotesMale' initialValue={genitourinary.genNotesMale} />
          </div>
          <PrimaryText>Female</PrimaryText><br />
          <div className={styles.section}>
            <SecondaryText>Female external genitalia assessment:</SecondaryText><br />
            <Checkbox field='genitourinary.noFemProbs' initialValue={genitourinary.noFemProbs} />No problems noted
          </div>
          <div className={styles.section}>
            <SecondaryText>Mark all that apply</SecondaryText><br />
            <Checkbox field='genitourinary.labLesions' initialValue={genitourinary.labLesions} />Labial lesions noted (describe in Notes)<br />
            <Checkbox field='genitourinary.femNodules' initialValue={genitourinary.femNodules} />Nodules<br />
            <Checkbox field='genitourinary.femInflame' initialValue={genitourinary.femInflame} />Inflammation<br />
            <Checkbox field='genitourinary.femRed' initialValue={genitourinary.femRed} />Redness<br />
            <Checkbox field='genitourinary.labSwell' initialValue={genitourinary.labSwell} />Labial swelling<br />
            <Checkbox field='genitourinary.femChancres' initialValue={genitourinary.femChancres} />Chancres<br />
            <Checkbox field='genitourinary.femPolyp' initialValue={genitourinary.femPolyp} />Polyp<br />
            <Checkbox field='genitourinary.femGenWarts' initialValue={genitourinary.femGenWarts} />Genital warts<br />
            <Checkbox field='genitourinary.femTrauma' initialValue={genitourinary.femTrauma} />Trauma noted<br />
            <Checkbox field='genitourinary.femNits' initialValue={genitourinary.femNits} />Nits or parasites<br />
            <Checkbox field='genitourinary.femDischargeBloody' initialValue={genitourinary.femDischargeBloody} />Vaginal discharge, bloody<br />
            <Checkbox field='genitourinary.femDischargeWhite' initialValue={genitourinary.femDischargeWhite} />Vaginal discharge, white<br />
            <Checkbox field='genitourinary.femDischargeCheesy' initialValue={genitourinary.femDischargeCheesy} />Vaginal discharge, cheesy<br />
            <Checkbox field='genitourinary.femDischargeFoul' initialValue={genitourinary.femDischargeFoul} />Vaginal discharge, foul odor<br />
            <Checkbox field='genitourinary.femDischargeGreen' initialValue={genitourinary.femDischargeGreen} />Vaginal discharge, green
          </div>
          <div className={styles.section}>
            <SecondaryText>Genitalia notes:</SecondaryText><br />
            <TextArea field='genitourinary.genNotesFemale' initialValue={genitourinary.genNotesFemale} />
          </div>
        </div>
      </ContentBox>
    );
  }
}

export default EditGenitourniary;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/progressNote/edit/EditGenitourinary.jsx